import React from 'react';
import ReactDOM from 'react-dom/client';
import './index.css';
import App from './App';

// The static-host fallback stores the intended route before returning to the app shell.
try {
  const pendingRoute = window.sessionStorage.getItem('pshr-portfolio-route');
  if (pendingRoute) {
    window.sessionStorage.removeItem('pshr-portfolio-route');
    window.history.replaceState(null, '', pendingRoute);
  }
} catch {
  // Storage is optional; routing remains available without the static-host helper.
}

const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
  <React.StrictMode>
    <App />
  </React.StrictMode>
);
